import React from 'react';
import { LayoutOpportunity } from './layout/LayoutOpportunity';

export const OpprtunityScreen = () => {
  return (
    <LayoutOpportunity />
  )
}
